import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _ from 'lodash';
import invariant from 'invariant';
/**
 * Run given data through all mappers found in the config and return
 * mapped data object
 * @param  {Object} data
 * @param  {Object} config
 * @return {Object}
 */

export function mapDataFromApi(data) {
  var _context;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var mappedData = _objectSpread({}, data);

  _forEachInstanceProperty(_context = config.mapData || []).call(_context, function (mapper) {
    invariant(_.isObject(mapper), "Your mapper must be an object, containing of a 'fromApi' and a 'toApi' node\n\n" + ' const mapper = {\n' + '   fromApi: data => doSomething(data),\n' + '   toApi: data => revertSomething(data)\n' + ' };');
    invariant(_.isFunction(mapper.fromApi), "The 'fromApi' node of this mapper doesn't seem to be a function!");

    if (mapper && _.isFunction(mapper.fromApi)) {
      mappedData = mapper.fromApi(mappedData);
    }
  });

  return mappedData;
}
/**
 * Run given data through mapper functions to serve it back to
 * the API ... usually reverting whatever `mapDataFromApi` changed!
 * @param  {Object} data
 * @param  {Object} config
 * @return {Object}
 */

export function mapDataToApi(data) {
  var _context2;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var mappedData = _objectSpread({}, data);

  _forEachInstanceProperty(_context2 = config.mapData || []).call(_context2, function (mapper) {
    invariant(_.isObject(mapper), "Your mapper must be an object, containing of a 'fromApi' and a 'toApi' node\n\n" + ' const mapper = {\n' + '   fromApi: data => doSomething(data),\n' + '   toApi: data => revertSomething(data)\n' + ' };');
    invariant(_.isFunction(mapper.toApi), "The 'toApi' node of this mapper doesn't seem to be a function!");
    mappedData = mapper.toApi(mappedData);
  });

  return mappedData;
}
/**
 * Apply callback function deeply on object through recursion
 * @param  {Object} object
 * @param  {Function} callback
 * @return {Object}
 */

export function deeply(object, callback) {
  invariant(_.isFunction(callback), 'The callback must be a function!');
  var mapped = callback(object);

  for (var key in mapped) {
    if (_.isObject(mapped[key])) {
      mapped[key] = deeply(mapped[key], callback);
    }
  }

  return mapped;
}